import { batch, useDispatch, useSelector } from 'react-redux';
import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectDeliveryZones,
  selectGroupedCountriesForDropdown,
  selectSelectedCountry,
  selectSelectedZoneCode,
} from 'src/redux/delivery/selectors';
import { actions as deliveryActions } from 'src/redux/delivery/slice';
import { selectProduct } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type { DeliveryBlockOnCountryChangeArgs, DeliveryBlockProps } from './types';

export const useDeliveryBlock = (): DeliveryBlockProps => {
  const dispatch = useDispatch<AppThunkDispatch>();

  const product = useSelector(selectProduct);
  const deliveryEvent = useSelector((state: ReduxApplicationState) => state.delivery.deliveryEvent);
  const selectedZoneCode = useSelector(selectSelectedZoneCode);
  const allDeliveryZones = useSelector(selectDeliveryZones);
  const groupedCountries = useSelector(selectGroupedCountriesForDropdown);
  const selectedCountry = useSelector(selectSelectedCountry);

  const deliveryZone = (allDeliveryZones || []).find((zone) => zone.zoneCode === selectedZoneCode);

  return {
    ...(deliveryEvent ? { deliveryEvent } : {}),
    deliveryZone,
    groupedCountries,
    onCountryChange: (payload: DeliveryBlockOnCountryChangeArgs) => {
      batch(() => {
        dispatch(deliveryActions.setSelectedZone(payload.selectedZone));
        dispatch(deliveryActions.setSelectedCountry(payload));
      });
    },
    onVisible: () => {
      deferTracking(() =>
        sendGAEvent({
          event: 'custom_event_v2',
          event_name: 'view_content',
          event_details: undefined,
          content_type: 'delivery information',
          item_id: undefined,
        }),
      );
    },
    partnerName: product.partner.name,
    photoUploadRequired: product.specialFeatures.requiresPhotoUpload || false,
    selectedCountry,
  };
};
